<app-message-handler></app-message-handler>
<sdds-theme name="scania"></sdds-theme>
<router-outlet></router-outlet>
 
